import styled from '@emotion/styled';
import { FC } from 'react';

import { TMenuItem } from '../../../types/common';
import { Logo } from '../../icons/logo';
import { MenuItem } from './menu-item';

type TProps = {
  list: TMenuItem[];
  mobileCourseDockReserved?: boolean;
  mobileChromeVisible?: boolean;
};

const Wrapper = styled('aside', {
  shouldForwardProp: (prop) => prop !== '$mobileChromeVisible',
})<{ $mobileChromeVisible: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  width: 140px;
  background-color: ${(props) => props.theme.COLORS.BLACK._400};
  max-height: 100vh;
  height: 100vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    background: transparent;
    width: 0;
    max-width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    width: 0;
    height: 0;
  }
  @media (max-width: 948px), (pointer: coarse) {
    width: 100%;
    height: var(--app-mobile-menu-height);
    max-height: none;
    bottom: 0;
    top: auto;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding-inline: 8px;
    transform: translateY(
      ${({ $mobileChromeVisible }) => ($mobileChromeVisible ? '0' : '110%')}
    );
    transition: transform 0.34s cubic-bezier(0.2, 0.82, 0.18, 1);
  }
`;

const LogoWrapper = styled('div')`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.COLORS.BLACK._400};
  padding-bottom: 16px;
  svg {
    margin-top: 16px;
  }

  @media (max-width: 948px), (pointer: coarse) {
    display: none;
  }
`;

const MenuList = styled('ul', {
  shouldForwardProp: (prop) =>
    prop !== '$itemCount' && prop !== '$mobileCourseDockReserved',
})<{ $itemCount: number; $mobileCourseDockReserved: boolean }>`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 948px), (pointer: coarse) {
    display: grid;
    grid-template-columns: repeat(
      ${({ $itemCount }) => Math.max($itemCount, 1)},
      minmax(0, 1fr)
    );
    width: 100%;
    box-sizing: border-box;
    padding-left: ${({ $mobileCourseDockReserved }) =>
      $mobileCourseDockReserved ? 124 : 0}px;
  }

  @media (max-width: 380px), (pointer: coarse) {
    padding-left: ${({ $mobileCourseDockReserved }) =>
      $mobileCourseDockReserved ? 112 : 0}px;
  }
`;

export const Menu: FC<TProps> = ({
  list,
  mobileCourseDockReserved = false,
  mobileChromeVisible = true,
}) => {
  return (
    <Wrapper $mobileChromeVisible={mobileChromeVisible}>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <MenuList
        $itemCount={list.length}
        $mobileCourseDockReserved={mobileCourseDockReserved}
      >
        {list.map((el) => (
          <MenuItem key={el.text} menuItem={el} />
        ))}
      </MenuList>
    </Wrapper>
  );
};
